import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { UpgradeMessage } from '../../containers/UpgradeMessage';
import { turnModalOff } from 'store/app/actions';
import { UpgradeMessageSource } from 'store/api/enums';
import { useSelector } from 'react-redux';
import { getAuthUser } from 'store/auth/selectors';
import { useTranslation } from 'react-i18next';

export const NotIncludedPage: React.FC = () => {
  const { t } = useTranslation();
  const currentUser = useSelector(getAuthUser);
  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t('navigation.upgrade')} | ${process.env.PROJECT_NAME}`}</title>
        <meta name="description" content={t('other.not-found-page-description')} />
      </Helmet>

      <div
        style={{
          background: 'var(--color-surface, #f3f7f8)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          gap: '40px',
          padding: '40px',
          minHeight: 'calc(100vh - 70px)',
        }}
      >
        <UpgradeMessage
          source={UpgradeMessageSource.VAT_CHECKER}
          onClose={() => {}}
          userAccountType={currentUser?.accountType}
          addPadding={true}
        />
      </div>
    </React.Fragment>
  );
};
